import { LIST_WIDTH } from 'utils/constants/listview';

export const subscriptionColumns = [
  {
    headerName: 'Plan Name',
    field: 'productName',
    width: LIST_WIDTH.OBJECT_NAME,
  },
  { headerName: 'Amount Due', field: 'amountDue', width: LIST_WIDTH.default },
  {
    headerName: 'Next Billing Date',
    field: 'nextBillingDate',
    width: LIST_WIDTH.TIME_DATE,
  },
  {
    headerName: 'Plan End Date',
    field: 'planEndDate',
    width: LIST_WIDTH.TIME_DATE,
  },
];
